// extracted by mini-css-extract-plugin
export var closeButton = "_nj-1";
export var closeX = "_nj-3";
export var container = "_nj-0";
export var image = "_nj-2";